import { StaticImageData } from '@rhg/libs/next/image';

/**
 * Resolves an image source to a URL string. Next.js statically imported images
 * are `StaticImageData` objects whose URL lives on `.src`; remote/string sources
 * are returned as-is.
 */
export function resolveImageSrc(src: string | StaticImageData): string {
    return typeof src === 'string' ? src : src.src;
}
